import { InternalUserResponse } from '../../../../web-api-client';
import { InternalUser } from '../../models';

export const mapInternalUserFromResponse = (
  response: InternalUserResponse
): InternalUser => ({
  id: response.id!,
  email: response.email!,
  firstName: response.firstName!,
  lastName: response.lastName!,
  fullName: `${response.firstName} ${response.lastName}`,
  isActive: response.isActive ?? false,
  modified: response.modified!,
});
